/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { MimeType } from '@constants';

export const getMimeType = (file: File) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = (e: ProgressEvent<FileReader>) => {
      if (e.target && e.target.readyState === FileReader.DONE) {
        const uint = new Uint8Array(e.target.result! as ArrayBuffer);
        const bytes: string[] = [];
        uint.forEach((byte) => {
          bytes.push(byte.toString(16));
        });
        const hex = bytes.join('').toUpperCase();

        let mimeType;

        switch (hex) {
          case '676C5446':
            mimeType = MimeType.GLB;
            break;
          default:
            mimeType = 'Unknown MimeType';
        }

        resolve(mimeType);
      }
    };
    reader.onerror = () => resolve('Unknown MimeType');
    reader.readAsArrayBuffer(file.slice(0, 4));
  });
};
